import { basic, withUniqueClass } from "../../helpers/block-helpers";

export const imageInput = basic.input({
    id: "basic-input-image",
    label: "Image",
    description: "An image, use it to add any image file to your page.",
    content: withUniqueClass(
        "img",
        (cls) =>
            `<img class="${cls}" src="" alt="" style="max-width:100%;height:auto;border-radius:8px;" />`
    ),
});